<template>
  <div>
    <h3>Organization Campaigns</h3>
    <el-table :data="campaigns" stripe fit>
      <el-table-column label="Active" width="70">
        <template slot-scope="scope">
          <i class="ic-true el-icon-circle-check" v-if="isActive(scope.row.expirationDate)"></i>
          <i class="ic-false el-icon-circle-close" v-else></i>
        </template>
      </el-table-column>
      <el-table-column prop="positionName" label="Name" width="120">
      </el-table-column>
      <el-table-column prop="skillCount" label="Skills" width="100">
      </el-table-column>
      <el-table-column
        prop="numberOfAssessments"
        label="Invitations"
        width="100"
      >
      </el-table-column>
      <el-table-column label="Type" width="100">
        <template slot-scope="scope">
          <span style="margin-left: 10px" v-if="scope.row.invitationEmail"
            >Email</span
          >
          <span style="margin-left: 10px" v-if="scope.row.openCampaign"
            >Public</span
          >
          <span
            style="margin-left: 10px"
            v-if="!scope.row.invitationEmail && !scope.row.openCampaign"
            >Private</span
          >
        </template>
      </el-table-column>
      <el-table-column label="Completion" width="120">
        <template slot-scope="scope">
          {{ scope.row.completionRatio }}%
        </template>
      </el-table-column>
      <el-table-column label="Avg Score" width="120">
        <template slot-scope="scope">
          {{ scope.row.averageScore == null ? 0 : Math.round(scope.row.averageScore) }}%
        </template>
      </el-table-column>
      <el-table-column label="Deadline" width="120">
        <template slot-scope="scope">
          {{ displayDate(scope.row.expirationDate) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "CampaignsOverview",
  props: {
    campaigns: {
      type: Array,
      required: true,
    },
  },
  methods: {
    isActive(end) {
      const today = moment()
      const en = moment(end)
      return today.isBefore(en)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~vars";

.ic-true, .ic-false {
  font-size: 24px;
  font-weight: bold;
}
.ic-true {
  color: green
}
.ic-false {
  color: red
}

.PAID {
  color: $-color-success;
}
.FREE {
  color: $-color-warning;
}
.EXPIRED {
  color: $-color-error;
}
</style>
